<button (click)="close()" mat-icon-button matTooltip="{{'common.button.close' | translate}}"
    [matTooltipShowDelay]="1000" matTooltipPosition="below" tabIndex="-1">
    <mat-icon>close</mat-icon>
</button>
<div></div>